import React, { useEffect, useState } from "react";
import ChangePassword from "../Components/ChangePassword";
import DeleteAccount from "../Components/DeleteAccount";
import useAuth from "../Hooks/useAuth";
import Schedule from "../Components/Schedule";
import ResetPasswordAdmin from "../Components/ResetPasswordAdmin";

const Settings = () => {
  const { auth } = useAuth();
  const values = {
    password: false,
    account: false,
    schedule: false,
    reset: false,
  };

  //by default shows change password
  const [active, setActive] = useState({
    password: true,
  });

  //function to change window tab
  const activeChange = (name) => {
    values[name] = true;
    setActive(values);
  };

  //passes the name to set true on button click
  const onChange = (name) => {
    activeChange(name);
  };

  return (
    <div className="row row-cols-md-2 m-3 m-md-5">
      <div className="col-md-2">
        <ul className="nav nav-pills flex-column">
          <li className="nav-item">
            <button
              className={`btn w-100 mb-2 nav-link ${
                active.password && "active"
              }`}
              onClick={() => onChange("password")}
            >
              Change Password
            </button>
          </li>
          {auth?.user?.roles === 0 && (
            <li className="nav-item">
              <button
                className={`btn w-100 mb-2 nav-link ${
                  active.reset && "active"
                }`}
                onClick={() => onChange("reset")}
              >
                Reset Password
              </button>
            </li>
          )}
          {auth?.user?.roles !== 0 && (
            <li className="nav-item">
              <button
                className={`btn w-100 nav-link ${active.account && "active"}`}
                onClick={() => onChange("account")}
              >
                Account
              </button>
            </li>
          )}
          {auth?.user?.roles !== 2 && (
            <li className="nav-item">
              <button
                className={`btn w-100 mb-2 nav-link ${
                  active.schedule && "active"
                }`}
                onClick={() => onChange("schedule")}
              >
                Manage Schedule
              </button>
            </li>
          )}
        </ul>
      </div>
      <div className="col-md-10 px-0 bg-light">
        {active.password ? (
          <ChangePassword />
        ) : active.reset ? (
          <ResetPasswordAdmin />
        ) : active.account ? (
          <DeleteAccount />
        ) : (
          <Schedule />
        )}
      </div>
    </div>
  );
};

export default Settings;
